// Mock data for development
import { User, Post, Notification } from '../types';

export const currentUser: User = {
  id: '550e8400-e29b-41d4-a716-446655440000',
  username: 'fluffybarkington',
  displayName: 'Sir Barksalot',
  profileImage: 'https://images.pexels.com/photos/2253275/pexels-photo-2253275.jpeg?auto=compress&cs=tinysrgb&w=300',
  bio: 'Just a fluffy golden retriever living my best life 🐾\nLove long walks, belly rubs, and making new friends!',
  followerCount: 2546,
  followingCount: 482,
  postCount: 127,
  isPrivate: false,
  website: 'https://fluffybarkington.com',
  location: 'San Francisco, CA',
  joinedDate: '2023-01-15T00:00:00Z'
};

export const users: User[] = [
  currentUser,
  {
    id: '550e8400-e29b-41d4-a716-446655440001',
    username: 'mittensthegreat',
    displayName: 'Mittens',
    profileImage: 'https://images.pexels.com/photos/45201/kitty-cat-kitten-pet-45201.jpeg?auto=compress&cs=tinysrgb&w=300',
    bio: 'Professional napper and yarn enthusiast 😺\nQueen of the household since 2020',
    followerCount: 3254,
    followingCount: 215,
    postCount: 89,
    isFollowing: true,
    isPrivate: false,
    location: 'New York, NY',
    joinedDate: '2022-08-20T00:00:00Z'
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440002',
    username: 'woofgang',
    displayName: 'Wolfgang',
    profileImage: 'https://images.pexels.com/photos/551628/pexels-photo-551628.jpeg?auto=compress&cs=tinysrgb&w=300',
    bio: 'German Shepherd with a passion for tennis balls and long walks 🐕\nProtector of the family, lover of treats',
    followerCount: 1842,
    followingCount: 367,
    postCount: 104,
    isFollowing: true,
    isPrivate: false,
    location: 'Austin, TX',
    joinedDate: '2023-03-10T00:00:00Z'
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440003',
    username: 'whiskerpaws',
    displayName: 'Whisker Paws',
    profileImage: 'https://images.pexels.com/photos/1170986/pexels-photo-1170986.jpeg?auto=compress&cs=tinysrgb&w=300',
    bio: 'Bengal cat with expensive taste 🐱\nModel by day, troublemaker by night',
    followerCount: 5281,
    followingCount: 512,
    postCount: 214,
    isFollowing: false,
    isPrivate: true,
    website: 'https://whiskerpaws.pet',
    location: 'Los Angeles, CA',
    joinedDate: '2022-11-05T00:00:00Z'
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440004',
    username: 'rexthewonder',
    displayName: 'Rex',
    profileImage: 'https://images.pexels.com/photos/58997/pexels-photo-58997.jpeg?auto=compress&cs=tinysrgb&w=300',
    bio: 'Adventure dog! Hiking, swimming, and chasing squirrels 🐕\nAlways ready for the next outdoor adventure',
    followerCount: 2187,
    followingCount: 431,
    postCount: 152,
    isFollowing: false,
    isPrivate: false,
    location: 'Denver, CO',
    joinedDate: '2023-05-22T00:00:00Z'
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440005',
    username: 'catlady',
    displayName: 'Luna',
    profileImage: 'https://images.pexels.com/photos/104827/cat-pet-animal-domestic-104827.jpeg?auto=compress&cs=tinysrgb&w=300',
    bio: 'Sleepy cat, don\'t wake me up unless it\'s for treats 😽\nExpert in finding the perfect sunbeam',
    followerCount: 1765,
    followingCount: 124,
    postCount: 67,
    isFollowing: true,
    isPrivate: false,
    location: 'Portland, OR',
    joinedDate: '2023-07-14T00:00:00Z'
  }
];

export const posts: Post[] = [
  {
    id: '650e8400-e29b-41d4-a716-446655440000',
    user: users[2],
    imageUrl: 'https://images.pexels.com/photos/1805164/pexels-photo-1805164.jpeg?auto=compress&cs=tinysrgb&w=600',
    caption: 'Just enjoying the sunset at the beach! What a perfect day! 🌊🐕',
    likeCount: 248,
    commentCount: 42,
    timestamp: '2h',
    location: 'Dog Beach, California',
    isLiked: true,
    isSaved: false,
  },
  {
    id: '650e8400-e29b-41d4-a716-446655440001',
    user: users[1],
    imageUrl: 'https://images.pexels.com/photos/2061057/pexels-photo-2061057.jpeg?auto=compress&cs=tinysrgb&w=600',
    caption: 'Nap time is the best time 😴',
    likeCount: 367,
    commentCount: 24,
    timestamp: '4h',
    isLiked: false,
    isSaved: true,
  },
  {
    id: '650e8400-e29b-41d4-a716-446655440002',
    user: users[4],
    imageUrl: 'https://images.pexels.com/photos/1254140/pexels-photo-1254140.jpeg?auto=compress&cs=tinysrgb&w=600',
    caption: 'Hiking day with my human! Made it to the top of Mount Pawsome 🏔️',
    likeCount: 512,
    commentCount: 78,
    timestamp: '1d',
    location: 'Mount Pawsome',
    isLiked: true,
    isSaved: true,
  },
  {
    id: '650e8400-e29b-41d4-a716-446655440003',
    user: users[5],
    imageUrl: 'https://images.pexels.com/photos/127028/pexels-photo-127028.jpeg?auto=compress&cs=tinysrgb&w=600',
    caption: 'Monday mood. Don\'t talk to me until I\'ve had my breakfast. 🙄',
    likeCount: 423,
    commentCount: 32,
    timestamp: '2d',
    isLiked: false,
    isSaved: false,
  },
  {
    id: '650e8400-e29b-41d4-a716-446655440004',
    user: users[3],
    imageUrl: 'https://images.pexels.com/photos/1404819/pexels-photo-1404819.jpeg?auto=compress&cs=tinysrgb&w=600',
    caption: 'Caught the perfect sunbeam today ☀️',
    likeCount: 621,
    commentCount: 45,
    timestamp: '3d',
    isLiked: true,
    isSaved: false,
  },
];

export const notifications: Notification[] = [
  {
    id: '750e8400-e29b-41d4-a716-446655440000',
    type: 'like',
    user: users[1],
    post: posts[0],
    timestamp: '2m',
    isRead: false,
  },
  {
    id: '750e8400-e29b-41d4-a716-446655440001',
    type: 'comment',
    user: users[2],
    post: posts[0],
    timestamp: '15m',
    isRead: false,
  },
  {
    id: '750e8400-e29b-41d4-a716-446655440002',
    type: 'follow',
    user: users[3],
    timestamp: '1h',
    isRead: true,
  },
  {
    id: '750e8400-e29b-41d4-a716-446655440003',
    type: 'mention',
    user: users[4],
    post: posts[2],
    timestamp: '3h',
    isRead: true,
  },
  {
    id: '750e8400-e29b-41d4-a716-446655440004',
    type: 'like',
    user: users[5],
    post: posts[1],
    timestamp: '1d',
    isRead: true,
  },
];

export const suggestedUsers = users.filter(user => !user.isFollowing && user.id !== currentUser.id).slice(0, 3);